import { Button } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import assest from "../../../json/assest";
import styles from "../../../styles/components/video.module.scss";
import TabPanel from "../../UtilitiesComponent/TabPanel";
import { emptyHandle, getUtcDateTime } from "../../../lib/functions/utils.lib";

const InquringStatus = ({
  handleCancle,
  notes,
  data,
  refetchNote,
  onClose,
}) => {
  //   console.warn("data", data);
  const [noteInfo, setNoteInfo] = useState();
  useEffect(() => {
    // if (notes) {
    notes?.map((note) => {
      if (note.type == "admin_inquery_reason") {
        setNoteInfo(note);
      }
    });
    // }
  }, [notes]);
  return (
    <>
      {/* <TabPanel value={data.manager_decision} index={3}>
        <Box className={`${styles.deleteBox} ${styles.inquirOrangeBox}`}>
          <Box className={styles.deleteBoxUP}>
            <p>
              Manager {emptyHandle(data.manager?.name)} is Inquiring about this
              video.
            </p>
          </Box>

          <Box className={styles.deleteBoxTxt}>
            <Box className={styles.justificationBox}>
              <h5>{emptyHandle(data.manager?.name)}’s Notes</h5>
            </Box>
            <p>Manager’s notes will be shown here</p>
            <p>Manager’s notes will be shown here</p>
            <p className={styles.dateTxt}>
              Date: {getUtcDateTime(data.video_meta.manager_updated_at)}
            </p>
          </Box>

          <Box className={styles.crossButton}>
            <Button onClick={onClose}>
              <img src={assest.crossBlack} width={21} height={21} alt="" />
            </Button>
          </Box>
        </Box>
      </TabPanel>
      <TabPanel value={data.quality_team_decision} index={3}>
        <Box className={`${styles.deleteBox} ${styles.inquirOrangeBox}`}>
          <Box className={styles.deleteBoxUP}>
            <p>
              QC Agent {emptyHandle(data.quality_team?.name)} is Inquiring about
              this video.
            </p>
          </Box>

          <Box className={styles.deleteBoxTxt}>
            <Box className={styles.justificationBox}>
              <h5>{emptyHandle(data.quality_team?.name)}’s Notes</h5>
            </Box>
            <p>QC Agent’s notes will be shown here</p>
            <p>QC Agent’s notes will be shown here</p>
            <p className={styles.dateTxt}>
              Date: {getUtcDateTime(data.video_meta.quality_team_updated_at)}
            </p>
          </Box>

          <Box className={styles.crossButton}>
            <Button onClick={onClose}>
              <img src={assest.crossBlack} width={21} height={21} alt="" />
            </Button>
          </Box>
        </Box>
      </TabPanel> */}
      {/* <TabPanel value={data.admin_decision} index={3}> */}
      <Box
        className={`${styles.deleteBox} ${styles.inquirOrangeBox} ${styles.inquirOrangeBoxEdit}`}
      >
        <Box className={styles.deleteBoxUP}>
          <p>You are Inquiring about this video </p>
          <Button onClick={handleCancle}>
            <img src={assest.cancelIconBlack} width={14} height={14} alt="" />{" "}
            Cancel
          </Button>
        </Box>

        {/* <Box className={styles.deleteBoxTxt}>
            <Box className={styles.justificationBox}>
              <h5>Justification</h5>
              <Button>
                <img src={assest.redEditIcon} height={14} width={14} alt="" />
              </Button>
            </Box>
            <p>your notes will be shown here</p>
            <p>your notes will be shown here</p>
          </Box>

          <Box className={styles.crossButton}>
            <Button onClick={onClose}>
              <img src={assest.crossBlack} width={21} height={21} alt="" />
            </Button>
          </Box> */}
        {noteInfo && (
          <>
            <Box className={styles.singleBorderInquring}></Box>

            <Box className={styles.deleteBoxTxt}>
              <Box className={styles.justificationBox}>
                <h5>Justification</h5>
                <Button
                // onClick={() => {
                //   setOpen(true);
                //   setNote(defaultNote);
                // }}
                >
                  <img src={assest.redEditIcon} height={14} width={14} alt="" />
                </Button>
              </Box>

              <Box className={styles.redRejectedBox}>
                {notes.map((note, i) => {
                  if (note.type == "admin_inquery_reason") {
                    return <p key={i}>{note.note}</p>;
                  }
                })}
              </Box>
            </Box>
          </>
        )}
        <Box className={styles.crossButton}>
          <Button onClick={onClose}>
            <img src={assest.crossBlack} width={21} height={21} alt="" />
          </Button>
        </Box>
      </Box>
      {/* </TabPanel> */}
    </>
  );
};

export default InquringStatus;
